"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureSearchAnalyticsTypes = exports.AnalyticEventTypes = exports.track = void 0;
const util_1 = require("../services/util");
const logger = __importStar(require("./logger"));
/**
 * Write a google analytics event, and log this analytics event data to splunk.
 * @param trackObj
 */
function track(trackObj) {
    try {
        if (window.dataLayer) {
            window.dataLayer.push(Object.assign({ event: AnalyticEventTypes.GAEvent }, trackObj));
        }
        (0, util_1.logAnalyticsEvent)(trackObj);
    }
    catch (error) {
        logger.warn(`[logging/analytics] Error tracking analytics event. ${error}`);
    }
}
exports.track = track;
var AnalyticEventTypes;
(function (AnalyticEventTypes) {
    AnalyticEventTypes["GAEvent"] = "GAEvent";
})(AnalyticEventTypes = exports.AnalyticEventTypes || (exports.AnalyticEventTypes = {}));
var SecureSearchAnalyticsTypes;
(function (SecureSearchAnalyticsTypes) {
    SecureSearchAnalyticsTypes["Category"] = "Secure Search";
    SecureSearchAnalyticsTypes["ErrorAction"] = "Secure Search Error";
})(SecureSearchAnalyticsTypes = exports.SecureSearchAnalyticsTypes || (exports.SecureSearchAnalyticsTypes = {}));
//# sourceMappingURL=analytics.js.map